import React from 'react';

import styles from './FreemiumFeaturesList.css';

const featuresList: Array<string> = [
    '+256 гигабайт в Облаке',
    'Добавление ещё 3 участников',
    'Безлимитная автозагрузка — у всех',
    'Без рекламы в Почте и Облаке',
    'Загрузка файлов до 100 ГБ в Облако',
    'Семейные папки и альбомы',
];

export const FreemiumFeaturesList = () => {
    return (
        <div className={styles.root}>
            {featuresList.map((feature, index) => (
                <li key={`${index}-${feature}`} className={styles.item}>
                    {feature}
                </li>
            ))}
        </div>
    );
};
